import api from './api';

const ownerProfileService = {
  /**
   * Récupère le profil public d'un owner/vendeur
   */
  getOwnerProfile: async (ownerId) => {
    const response = await api.get(`/owners/${ownerId}`);
    return response.data;
  },

  /**
   * Récupère les listings et/ou produits d'un owner
   * @param {string} ownerId
   * @param {Object} params - { type, categoryId, minPrice, maxPrice, city, condition, search, sortBy, sortOrder, page, limit }
   */
  getOwnerItems: async (ownerId, params = {}) => {
    const response = await api.get(`/owners/${ownerId}/items`, { params });
    return response.data;
  }
};

export default ownerProfileService;
